/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import * as React from 'react';
import {
    EntityAttributeWithStaticUnitProps,
    EntityAttribute,
    EntityAttributeState,
} from './EntityAttribute';
import {DefaultEntityAttribute} from './DefaultEntityAttribute';
import {FLOAT_ENTITY_ATTRIBUTE_DEFAULT_PROPS} from './FloatEntityAttribute';
import {buildFloatAttributeValidation, getDisplayText} from './commons';

/**
 * The default props for a float entity attribute
 */
export const FLOAT_ENTITY_ATTRIBUTE_WITH_UNIT_DEFAULT_PROPS = {
    ...FLOAT_ENTITY_ATTRIBUTE_DEFAULT_PROPS,
    validateValue: buildFloatAttributeValidation(undefined, undefined),
    onFieldInputEnded: (
        component: EntityAttribute<
            EntityAttributeWithStaticUnitProps,
            EntityAttributeState
        >,
        input: string
    ) => {
        if (
            input.length === 0 &&
            !component.props.isRequired(component.props.attribute)
        ) {
            // the new value is empty and not required
            // => convert to unset value
            return component.props.onFieldEditedValue(component, null);
        }
        try {
            let value = Number.parseFloat(input);
            value = component.props.toStorageUnit(value);
            component.props.onFieldEditedValue(component, value);
        } catch (error) {
            // not a number?
            component.props.onFieldEditedValue(component, input);
        }
    },
    renderInput: (
        component: EntityAttribute<
            EntityAttributeWithStaticUnitProps,
            EntityAttributeState
        >
    ) => {
        let text = getDisplayText(
            component.props.toCurrentUnit(component.state.value)
        );
        return (
            <input
                type={'number'}
                disabled={component.props.disabled}
                required={component.props.isRequired(component.props.attribute)}
                value={text}
                onChange={(event) =>
                    component.props.onFieldChange(component, event)
                }
                onBlur={(event) =>
                    component.props.onFieldBlur(component, event)
                }
            />
        );
    },
    renderTitle: (
        component: EntityAttribute<
            EntityAttributeWithStaticUnitProps,
            EntityAttributeState
        >
    ) => {
        return (
            <span>{`${component.context.translate(
                component.props.attribute.name
            )} [${component.props.unitName}]`}</span>
        );
    },
    toCurrentUnit: (value: any) => value,
    toStorageUnit: (value: number) => value,
};

/**
 * Component for rendering a float entity attribute
 */
export class FloatEntityAttributeWithStaticUnit extends React.Component<EntityAttributeWithStaticUnitProps> {
    public static defaultProps = FLOAT_ENTITY_ATTRIBUTE_WITH_UNIT_DEFAULT_PROPS;

    render() {
        return <DefaultEntityAttribute {...this.props} />;
    }
}
